import { cleanQuillHTML } from "../helper/cleanQuillHTML";

export const renderSafeHtml = (html) => {
  return cleanQuillHTML(html);
};